import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[600px] md:min-h-[750px] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20stylized%20artistic%20illustration%20of%20a%20comic%20book%20library%20with%20floating%20manhwa%20pages%20and%20panels%2C%20warm%20dark%20atmosphere%20with%20soft%20ambient%20lighting%2C%20abstract%20geometric%20shapes%2C%20modern%20minimalist%20design%2C%20subtle%20gradients%20in%20warm%20tones%2C%20clean%20composition%2C%20no%20text%20visible%2C%20dark%20moody%20background&width=1800&height=900&seq=hero-bg-2026&orientation=landscape"
          alt="韩漫在线阅读背景"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/35 to-black/60"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6">
        <div className="max-w-[1200px] mx-auto text-center">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-background-50/15 backdrop-blur-sm border border-background-50/20 mb-6">
            <span className="w-2 h-2 rounded-full bg-accent-500 animate-pulse"></span>
            <span className="text-xs md:text-sm text-background-50/90 font-medium">每日更新 120+ 话热门韩漫</span>
          </div>

          <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 leading-tight max-w-3xl mx-auto font-heading">
            免费韩国漫画大全
            <span className="block text-xl md:text-2xl lg:text-3xl font-normal mt-3 text-background-50/80">
              全集下拉式阅读 · 随时随地畅享韩漫
            </span>
          </h1>

          <p className="mt-6 text-sm md:text-base text-background-50/70 max-w-xl mx-auto leading-relaxed">
            韩漫网收录超过<strong className="text-background-50">8,500部</strong>优质韩国漫画，支持手机和电脑在线阅读。
            无需下载，即点即看，下拉式阅读让您的漫画体验更流畅。
          </p>

          <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/category/rexue"
              className="px-8 py-3.5 bg-primary-500 text-background-50 text-sm md:text-base font-semibold rounded-lg hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-book-open-line mr-2"></i>
              立即开始阅读
            </Link>
            <Link
              to="/#popular"
              className="px-8 py-3.5 bg-background-50/10 backdrop-blur-sm border border-background-50/30 text-background-50 text-sm md:text-base font-medium rounded-lg hover:bg-background-50/20 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-fire-line mr-2"></i>
              查看热门推荐
            </Link>
          </div>

          <div className="mt-12 grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6 max-w-2xl mx-auto">
            {[
              { num: '8,500+', label: '漫画资源' },
              { num: '320万', label: '活跃读者' },
              { num: '120+', label: '每日更新' },
              { num: '15亿+', label: '累计阅读' },
            ].map((stat) => (
              <div key={stat.label} className="text-center">
                <div className="text-xl md:text-2xl font-bold text-background-50 font-heading">{stat.num}</div>
                <div className="text-xs md:text-sm text-background-50/60 mt-1">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}